import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
import { blocklyStore } from '../blocklyStore';
import { BlockType } from '../../@types/BlockType';
import { SceneCodeSetting } from '../setting/SceneCodeSetting';
import { block_translation } from '../../lang/BlockTranslation';

const t = block_translation;

export class SceneStartBlock extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.SCENE_START, t.to('シーンスタート', 'scene_start'));
    this.setNameForCode('a-scene');
    // this.setLibrary(`https://aframe.io/releases/1.2.0/aframe.min.js`);
    this.setLibrary(`../public/libs/aframe.min.js`);
    // this.setLibrary(
    //   `https://cdn.jsdelivr.net/gh/donmccurdy/aframe-extras@v6.1.1/dist/aframe-extras.min.js`
    // );
    this.setLibrary(`../public/libs/aframe-extras.min.js`);

    // this.setLibrary(`https://cdnjs.cloudflare.com/ajax/libs/socket.io/2.3.0/socket.io.slim.js`);
    this.setLibrary(`../public/libs/socket.io.slim.js`);
    // this.setLibrary(`https://unpkg.com/networked-aframe@0.8.0/dist/networked-aframe.min.js`);
    this.setLibrary(`../public/libs/networked-aframe.min.js`);
    // this.setLibrary(`../easyrtc/easyrtc.js`);
    this.setLibrary(`../public/helper_bundle.js`);
  }

  /**
   * ネットワーク AFRAMEの設定
   * @param {プロジェクトID}} project_id
   * @param {有効無効} hasAtt
   * @returns
   */
  getNetworkedSceneAtt(project_id: string, is_init: string): string {
    if (is_init === 'off') return '';
    const sound = is_init === 'on_without_sound' ? '' : 'audio: true;';
    // return CodeSetting.getAttributeCode(
    //   'networked-scene',
    //   `serverURL:https://blockvrock.com;room: ${project_id}; connectOnLoad:false; debug: true; ${sound}`
    // );
    return CodeSetting.getAttributeCode(
      'blockvrock-networked-scene',
      `serverURL:https://blockvrock.com;room: ${project_id}; connectOnLoad:false; debug: true; ${sound}`
    );
  }

  defineBlock(block: BlockType): void {
    ColorSettings.setSceneColor(block);
    ShapeSettings.setSceneStartShape(block);
    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.setTitleField(block, t.to('空間共有', 'space_share'));

    const is_init = ShapeSettings.getDropDown([
      ['OFF', 'off'],
      ['ON', 'on_without_sound'],
      [t.to('ON(通話あり)', 'on_with_sound'), 'on'],
    ]);

    block.appendDummyInput().appendField(is_init, 'is_init');

    ShapeSettings.setTitleField(block, t.to('コントローラ表示', 'controller_ui'));
    const hasController = ShapeSettings.getDropDown([
      ['ON', 'on'],
      ['OFF', 'off'],
    ]);
    block.appendDummyInput().appendField(hasController, 'hasController');

    ShapeSettings.addAttributeOfSceneStartInput(block);
    ShapeSettings.addStatementInput(block);
  }

  generateStaticHTMLCode(block: BlockType): string {
    const html = `<a id="myEnterARButton" href="#"></a>
    `;
    return html;
  }

  // a-asset-itemがないとa-assetそのものが評価されないよう。
  // template だけではいけない？
  generateAssetsHTMLCode(): string {
    return `
      <a-asset-item id="avator0" src="../public/avator/teat_Avatar_ver0.glb" crossorigin="anonymous" response-type="arraybuffer"></a-asset-item>
      <template id="entity-template" >
        <a-entity ></a-entity>
      </template>
    `;
  }

  generateAfterbodyJavaScriptCode(block: BlockType): string {
    return `
      NAF.schemas.add({
        template: '#entity-template',
        components: [
          'position',
          'rotation',
          'scale',
          'color',
          'vrm',
          'vrm-anim',
          'animation-mixer',
          'gltf-model',
          'material',
          'geometry'
        ],
      });
    `;
  }

  codeGenerateCore(block: BlockType): string {
    // console.log("SceneStartBlock" ,self);
    const is_init = CodeSetting.getFieldValue(block, 'is_init');

    // シーンの属性
    let attribute = '';

    if (is_init === 'on' || is_init === 'on_without_sound') {
      attribute += CodeSetting.getAttributeCode('networked-blockvrock', '');
    }

    attribute += CodeSetting.getAttributeCode('blockvrock-init', '');
    // attribute += CodeSetting.getAttributeCode('blockvrock-edited-code', '');
    attribute += this.getNetworkedSceneAtt(blocklyStore.project_id, is_init);
    attribute += CodeSetting.getAttributeCode('vr-mode-handler', '');
    attribute += CodeSetting.getAttributeCode('renderer', 'colorManagement: true');
    attribute += CodeSetting.getAttributeCode('vr-mode-ui', 'enterARButton: #myEnterARButton');
    attribute += CodeSetting.getAttributeCode(
      'gltf-model',
      'dracoDecoderPath:../public/draco/gltf/'
    );
    // JSCodeをロード
    attribute += CodeSetting.getAttributeCode('ready', '');
    attribute += CodeSetting.getAttributeCode(
      'device-orientation-permission-ui',
      `enabled:true;
       denyButtonText:いいえ;
       allowButtonText:はい;
       cancelButtonText:キャンセル;
       deviceMotionMessage:向きのセンサーにアクセスしてよろしいですか;
       mobileDesktopMessage:<a href='../public/ui/mobile_safari.jpg' >こちら</a>の手順に従って、
       モバイル用Webサイトに切り替えてこの画面をリロードしてください`
    );

    // TODOコントローラー
    const hasController = CodeSetting.getFieldValue(block, 'hasController');
    if (hasController === 'on') {
      attribute += CodeSetting.getAttributeCode('ui-controller', 'rig:#rig');
    }

    attribute += CodeSetting.getSubAttributeCode(block);
    const str = SceneCodeSetting.getSceneCode(attribute, block);

    return str;
  }
}
